function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  fill: "#101010",
  width: 50,
  height: 50,
  rx: 3
}), React.createElement("path", {
  d: "M23.677 31.46C19.995 31.46 17 28.62 17 25.126c0-1.905.892-3.692 2.45-4.902-1.016-1.155-1.477-2.679-1.304-4.25.315-2.835 2.77-4.973 5.712-4.973h2.228c.54 0 .98.442.98.987v1.473c0 .545-.44.988-.98.988h-2.409c-1.176 0-2.098.954-2.098 2.172 0 1.216.922 2.17 2.098 2.17.54 0 .978.443.978.987v1.474a.983.983 0 01-.978.987c-1.748.001-3.117 1.27-3.117 2.887 0 1.616 1.37 2.88 3.117 2.88 1.748 0 3.118-1.264 3.118-2.88v-5.347c0-.545.438-.988.978-.988h3.284c.54 0 .977.443.977.988v1.472a.983.983 0 01-.977.988h-.93c0 3.712.888 5.202 2.622 5.693.429.121.751.507.751.984v1.663c0 .457-.363.83-.81.83-2.06 0-3.437-1.556-3.933-2.224-1.231 1.448-3.098 2.277-5.08 2.277zm8.898 4.153c.494 0 .896.406.896.905v1.575c0 .501-.402.907-.896.907H18.162a.902.902 0 01-.897-.907v-1.575c0-.5.402-.905.897-.905h14.413z",
  fill: "#FFF"
}));

const SvgLogo = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 50,
  height: 50,
  viewBox: "0 0 50 50",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;